export class Guid {
  private value: string = this.empty;

  constructor(value?: string) {
    if (value) {
      if (this.isValid(value)) {
        this.value = value;
      }
    }
  }

  public toString() {
    return this.value;
  }

  public toJSON(): string {
    return this.value;
  }

  public newGuid(): Guid {
    return new Guid(
      'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c: any) => {
        /* tslint:disable:no-bitwise */
        const r = c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)));
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        /* tslint:enable:no-bitwise */
        return v.toString(16);
      })
    );
  }

  public static get empty(): string {
    return '00000000-0000-0000-0000-000000000000';
  }

  public get empty(): string {
    return Guid.empty;
  }
  public isValid(str: string): boolean {
    const validRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return validRegex.test(str);
  }
}

export default new Guid();
